// TODO: Temporary for scope-to-gyro-grant transition. Remove once migration to gyro grant checks is complete.
export const AccessCheckMode = {
  RESOURCE: 'resource',
  SCOPE: 'scope',
  NO_SCOPE: 'no-scope'
};